// extracted by mini-css-extract-plugin
export default {"externalLink":"lslbHt"};